<div class="optimization-debug-layout">
  <!-- ===== LISTE DES RUNS ===== -->
  <p-card>
    <div class="flex align-items-center gap-2 mb-3">
      <i class="pi pi-search text-xl"></i>
      <h2 class="m-0">Debug — Runs d'optimisations</h2>
      <div class="ml-auto flex gap-2">
        <p-button
          icon="pi pi-refresh"
          label="Actualiser"
          severity="secondary"
          [outlined]="true"
          [loading]="(loading$ | async) ?? false"
          (onClick)="refreshRuns()"
          pTooltip="Recharger la liste des runs"
          tooltipPosition="bottom"
        />
        <p-button
          icon="pi pi-play"
          label="Forcer sync + run"
          severity="help"
          [loading]="(actionLoading$ | async) ?? false"
          (onClick)="forceSyncAndRun()"
          pTooltip="Synchronise le vivier puis lance une nouvelle optimisation (synchrone, bloquant)"
          tooltipPosition="bottom"
        />
        <p-button
          icon="pi pi-bolt"
          label="Run async"
          severity="info"
          [loading]="(actionLoading$ | async) ?? false"
          (onClick)="forceSyncAndRunAsync()"
          pTooltip="Synchronise le vivier puis dispatche l'optimisation sur la queue 'optimization' (workers en parallèle, retour immédiat)"
          tooltipPosition="bottom"
        />
      </div>
    </div>

    <p-table
      [value]="(runs$ | async) || []"
      [loading]="(loading$ | async) ?? false"
      [lazy]="true"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[10, 20, 50]"
      [totalRecords]="(total$ | async) || 0"
      (onLazyLoad)="onLazyLoad($event)"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-hoverable-rows"
      dataKey="id"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>#</th>
          <th>Statut</th>
          <th>Période</th>
          <th>Affaires</th>
          <th>Couverture</th>
          <th>Techniciens</th>
          <th>Durée run</th>
          <th>Créé le</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-run>
        <tr class="cursor-pointer" (click)="openRun(run)">
          <td>
            <span class="font-mono text-sm">#{{ run.id }}</span>
          </td>
          <td>
            <p-tag
              [value]="getStatusLabel(run.status)"
              [severity]="getStatusSeverity(run.status)"
            ></p-tag>
          </td>
          <td class="text-sm">
            @if (run.dateFrom && run.dateTo) {
              {{ run.dateFrom | date: 'dd/MM/yy' }} →
              {{ run.dateTo | date: 'dd/MM/yy' }}
            } @else {
              <span class="text-color-secondary">—</span>
            }
          </td>
          <td>
            @if (run.affairsCount !== null) {
              <span class="font-semibold">{{ run.affairsWithSlotsCount }}</span>
              <span class="text-color-secondary text-xs">
                / {{ run.affairsCount }}</span
              >
            } @else {
              <span class="text-color-secondary">—</span>
            }
          </td>
          <td>
            @if (coveragePercent(run); as pct) {
              <span
                class="font-semibold"
                [class.text-green-500]="pct >= 80"
                [class.text-orange-500]="pct >= 50 && pct < 80"
                [class.text-red-500]="pct < 50"
                >{{ pct }}%</span
              >
            } @else {
              <span class="text-color-secondary">—</span>
            }
          </td>
          <td>{{ run.techniciansCount ?? '—' }}</td>
          <td class="text-sm font-mono">
            {{ formatDuration(run.durationSec) }}
          </td>
          <td class="text-sm text-color-secondary">
            {{ run.createdAt | date: 'dd/MM/yy HH:mm' }}
          </td>
          <td (click)="$event.stopPropagation()">
            <div class="flex gap-1 align-items-center justify-content-end">
              @if (canCancel(run)) {
                <p-button
                  icon="pi pi-times"
                  severity="danger"
                  [text]="true"
                  [rounded]="true"
                  [loading]="(actionLoading$ | async) ?? false"
                  (onClick)="cancelRun(run, $event)"
                  pTooltip="Annuler ce run"
                  tooltipPosition="left"
                />
              }
              <i class="pi pi-chevron-right text-color-secondary"></i>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="text-center text-color-secondary py-4">
            <i class="pi pi-inbox mr-2"></i>Aucun run trouvé
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
